Pollfish.adGateTracking = (function adGateTracking() {
  let alreadyCalled = false;

  return {
    init({ wallCode, deviceId }) {
      if (
        Pollfish.helper.isDebugMode() ||
        Pollfish.helper.isCypressEnv() ||
        !Pollfish.helper.isOfferwall() ||
        !Pollfish.helper.getOfferwallOffersEnabled() ||
        alreadyCalled ||
        !wallCode
      ) {
        return;
      }

      // eslint-disable-next-line func-names, camelcase
      (function(wall_code, user_id, sub_ids, container) {
        const script = document.createElement('script');
        script.src = 'https://api.adgatemedia.com/apps/sdk/sdk.min.js';
        script.async = true;
        script.onload = () => {
          // eslint-disable-next-line no-undef
          const sdk = new OfferWallSDK(wall_code, user_id, sub_ids);
          sdk.registerImpressionHandler(container);
        };
        document.body.appendChild(script);
        alreadyCalled = true;
      })(
        // ONLY CHANGE THE VALUES BELOW
        // wall_code parameter value.
        wallCode,
        // user_id parameter value.
        deviceId,
        // s2, s3, s4, s5 parameter values.
        {},
        // Offers container selector. SDK will track
        // the impressions for all elements that have
        // offer id set via "data-ow-sdk-offer-id" data attribute.
        '#js-offerwall-container-offers',
      );
    },
    hasInitBeenCalled() {
      return alreadyCalled;
    },
  };
})();

export default Pollfish.adGateTracking;
